import axios from 'axios';

const acceptPolicy = () => {
  return axios.put('voip/settings/accept');
};

export { acceptPolicy };
